export default {"src":"/_next/static/media/MenuBlue.47585ded.svg","height":18,"width":24};